export default __webpack_public_path__ + "static/media/philosophies_of_gold.6c70a0a3.png";